export default {
  'reportTokens.title': 'Manage Report Tokens',
  'reportTokens.showToken': 'Show token',
  'reportTokens.accept': 'Accept',
  'reportTokens.traces': 'Traces',
  'reportTokens.traces.description': 'Review request traces for the selected report token.',
  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reportTokens.type.administration': 'Administration',
  'reportTokens.type.process': 'Process',
  'reportTokens.type.request': 'Request',
  'reportTokens.type.generic': 'Generic',
  'reportTokens.type.powerbiconnector': 'Power BI Connector',
  'reportTokens.type.tableauconnector': 'Tableau Connector',
  'token.processInstance': 'Request',
  'token.administration': 'Administration',
  'token.process': 'Process',
  'token.request': 'Request',
  'token.generic': 'Generic',
  'token.reportToken': 'Report Token',
  'token.powerBIConnector': 'Power BI Connector',
  'token.dynamicEntity': 'Entity',
  'token.trace': 'Trace',
  'token.dataType': 'Data Type',
  'token.headers': 'Headers',
  'token.isSuccessfullyRequest': 'Successful Request?',
  'token.logs': 'Logs',
  'token.reportTokenId': 'Report Token',
  'token.ip': 'IP',
};
